import React, { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'

const SessionContext = createContext()

const SessionProvider = ({ children }) => {
  const [sessionData, setSessionData] = useState({})

  return (
    <SessionContext.Provider
      value={{
        sessionData,
        setSessionData,
      }}
    >
      {children}
    </SessionContext.Provider>
  )
}

const useSession = () => useContext(SessionContext)

export { SessionContext, SessionProvider, useSession }

SessionProvider.propTypes = {
  children: PropTypes.element.isRequired,
}
